import React from "react";

/**
 * Temporary debug boundary — surfaces React render errors instead of white screen.
 */
export default class RouteCrashBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[bootCheck] React crash boundary caught error", error, info);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            background: "#111",
            color: "#fff",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <div style={{ maxWidth: 640 }}>
            <h1 style={{ marginTop: 0 }}>React crash</h1>
            <p style={{ wordBreak: "break-word" }}>{error.message || String(error)}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
